import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";
import type { Invitation } from "../types/team";

export function useInvitations() {
  return useQuery<Invitation[], Error>({
    queryKey: ["invitations"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_invitations");

      if (error) {
        throw new Error(error.message);
      }

      return data as Invitation[];
    },
  });
}
